import { Injectable } from '@angular/core';
import { AppStateModel } from '@libs/shared/models';
import { Observable } from 'rxjs';
import { AppStateQuery } from './app-state.query';
import { AppStateStore } from './app-state.store';

type StateName = keyof AppStateModel;
type StateValue<T extends StateName> = AppStateModel[T];

@Injectable({ providedIn: 'platform' })
export class AppStateService {
  public constructor(
    private readonly store: AppStateStore,
    private readonly query: AppStateQuery,
  ) {
  }

  public set<TKey extends StateName>(key: TKey, value: StateValue<TKey>): void {
    this.store.update({ [key]: value });
  }

  public get<TKey extends StateName>(key: TKey): Observable<StateValue<TKey> | undefined> {
    return this.query.select(key);
  }

  public clear<TKey extends StateName>(key: TKey): void {
    this.set(key, undefined);
  }
}
